"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const BookComponent_1 = __importDefault(require("../../../components/bookComponent/BookComponent"));
const Properties_1 = require("../../../hooks/Properties");
const NoAvailableSuites_1 = __importDefault(require("../noAvailableSuites/NoAvailableSuites"));
require("./BookGalery.scss");
const NUMBER_OF_SELECTED_PROPERTIES = 1;
const BookGalery = ({ data, queryURL, propertiesLength, loadMoreFunc, isLastPage, requestError, }) => {
    const propContext = (0, Properties_1.useProperties)();
    const [selectedCategories, setSelectedCategories] = (0, react_1.useState)([]);
    const [buildingName, setBuildingName] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!!data.availableQuantity && !!(queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) && propContext.properties) {
            if (((_a = queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) === null || _a === void 0 ? void 0 : _a.length) === NUMBER_OF_SELECTED_PROPERTIES) {
                const building = propContext === null || propContext === void 0 ? void 0 : propContext.properties.find(property => { var _a; return property.propId.toString() === ((_a = queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) === null || _a === void 0 ? void 0 : _a[0]); });
                setBuildingName((building === null || building === void 0 ? void 0 : building.name) || '');
            }
            else if (((_b = queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) === null || _b === void 0 ? void 0 : _b.length) > NUMBER_OF_SELECTED_PROPERTIES &&
                !!queryURL.selectedDate &&
                queryURL.selectedDate.length > 1)
                setBuildingName('someWithDate');
            else if (((_c = queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) === null || _c === void 0 ? void 0 : _c.length) > NUMBER_OF_SELECTED_PROPERTIES &&
                !!queryURL.selectedDate &&
                ((_d = queryURL === null || queryURL === void 0 ? void 0 : queryURL.selectedDate) === null || _d === void 0 ? void 0 : _d.length) < 1)
                setBuildingName('someWithoutDate');
            else if (((_e = queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) === null || _e === void 0 ? void 0 : _e.length) === NUMBER_OF_SELECTED_PROPERTIES &&
                !!queryURL.selectedDate &&
                !!queryURL.selectedDate.length)
                setBuildingName('buildingWithoutDate');
            else if (((_f = queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) === null || _f === void 0 ? void 0 : _f.length) < NUMBER_OF_SELECTED_PROPERTIES &&
                !!queryURL.selectedDate &&
                queryURL.selectedDate.length < 1)
                setBuildingName('anyWithoutDate');
            else if (((_g = queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) === null || _g === void 0 ? void 0 : _g.length) < NUMBER_OF_SELECTED_PROPERTIES &&
                !!queryURL.selectedDate &&
                queryURL.selectedDate.length > 1)
                setBuildingName('anyWithDate');
        }
    }, [propContext.properties, data.availableQuantity, queryURL]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        data.isEmptyRooms && react_1.default.createElement(NoAvailableSuites_1.default, { buildingName: buildingName, requestError: requestError }),
        react_1.default.createElement("div", { className: "BookGalery" },
            react_1.default.createElement("div", { className: "galery-menu" },
                react_1.default.createElement("div", { className: "categories-container" }, data.categories.map(item => {
                    const selected = queryURL && queryURL.category && queryURL.category.indexOf(item.name) !== -1;
                    return (react_1.default.createElement("div", { key: item.id, className: `category-item ${selected ? 'selected' : ''}`, onClick: () => {
                            if (selected) {
                                setSelectedCategories(selectedCategories.filter(v => v !== item.id));
                            }
                            else {
                                setSelectedCategories([...selectedCategories, item.id]);
                            }
                        } },
                        react_1.default.createElement("span", { className: "category-name" }, item.name),
                        react_1.default.createElement("span", { className: "category-quantity" }, item.quatity)));
                }))),
            data.bookList && (react_1.default.createElement(react_bootstrap_1.Row, null, data.bookList.map(v => {
                let noAvailableSuites = false;
                if (queryURL && (queryURL === null || queryURL === void 0 ? void 0 : queryURL.guests) && data.isEmptyRooms) {
                    if (v.maxPeople < queryURL.guests) {
                        noAvailableSuites = true;
                    }
                }
                return (react_1.default.createElement(react_bootstrap_1.Col, { key: v.roomId, xs: 12, sm: 12, md: 6, lg: 6, xl: 4, className: "book-item" },
                    react_1.default.createElement(BookComponent_1.default, { suite: v, noAvailableSuites: noAvailableSuites, queryURL: queryURL, propertiesLength: propertiesLength })));
            }))),
            !isLastPage && (react_1.default.createElement("div", { className: "load-more", onClick: loadMoreFunc }, "carregar mais su\u00EDtes...")))));
};
exports.default = BookGalery;
